export default __webpack_public_path__ + "static/media/Asia_04.c2cc2cee.png";